<template>
  <div>
    <h2> Subscription Field </h2>
  </div>
</template>

<script>
import option_field from "../../../mixin/option-field.js";
export default {
  name: "field_subscription",
  mixins: [option_field],
  data: function() {
    return {}
  }
}
</script>

<style scoped>

</style>